import { Card, CardContent, CardHeader, Grid } from "@mui/material"
import InfoBox from "../../../../common/InfoBox"
import { DualAxisChart } from "../../../charts/CompositChart"
import { numberPrecision } from "../../../../helpers/UtilityHelper"
import { PAYMENT_COLORS, ACCENT } from "../../../charts/colors"

const chartOptions = {
    layout: 'horizontal',
    xaxis: 'name',
    showLabels: true,
    legendAlign: 'left',
    yaxis: {
        left: {
            label: '# Shipments',
            data: [
                {
                    dataKey: 'PREPAID',
                    label: '# Prepaid Shipments',
                    chartType: 'bar',
                    fill: PAYMENT_COLORS.PREPAID,
                },
                {
                    dataKey: 'COD',
                    label: '# COD Shipments',
                    chartType: 'bar',
                    fill: PAYMENT_COLORS.COD,
                },
            ],
        },
        right: {
            label: 'COD %',
            domain: [0, 100],
            data: [
                {
                    dataKey: 'codPercentage',
                    label: 'COD %',
                    chartType: 'line',
                    fill: ACCENT.red,
                    unit: '%',
                },
            ],
        },
    },
}

export default function PaymentModeTrends({ data }) {
    return (
        <Card elevation={1}>
            <CardHeader
                title="Payment Mode Trends"
                subheader="This chart shows the distribution of COD vs Prepaid shipments over the selected period."
            />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={3} md>
                        <InfoBox header="Prepaid Shipments" value={numberPrecision(data?.prepaidOrderCount)} />
                    </Grid>
                    <Grid item xs={6} sm={3} md>
                        <InfoBox header="Prepaid Shipment %" value={`${numberPrecision(100 - (data?.codPercentage || 0))}%`} />
                    </Grid>
                    <Grid item xs={6} sm={3} md>
                        <InfoBox header="COD Shipments" value={numberPrecision(data?.codOrderCount)} />
                    </Grid>
                    <Grid item xs={6} sm={3} md>
                        <InfoBox header="COD Shipment %" value={`${numberPrecision(data?.codPercentage)}%`} />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <DualAxisChart data={data?.lineChartData || []} chartOptions={chartOptions} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
